"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.markAllReadDone = exports.markAllReadError = exports.markAllReadPending = exports.markAllRead = exports.INBOX_MARK_ALL_READ_ERROR = exports.INBOX_MARK_ALL_READ_DONE = exports.INBOX_MARK_ALL_READ_PENDING = exports.INBOX_MARK_ALL_READ = void 0;
var INBOX_MARK_ALL_READ = "inbox/MARK_ALL_READ";
exports.INBOX_MARK_ALL_READ = INBOX_MARK_ALL_READ;
var INBOX_MARK_ALL_READ_PENDING = "inbox/MARK_ALL_READ/PENDING";
exports.INBOX_MARK_ALL_READ_PENDING = INBOX_MARK_ALL_READ_PENDING;
var INBOX_MARK_ALL_READ_DONE = "inbox/MARK_ALL_READ/DONE";
exports.INBOX_MARK_ALL_READ_DONE = INBOX_MARK_ALL_READ_DONE;
var INBOX_MARK_ALL_READ_ERROR = "inbox/MARK_ALL_READ/ERROR";
exports.INBOX_MARK_ALL_READ_ERROR = INBOX_MARK_ALL_READ_ERROR;

var markAllRead = function markAllRead() {
  return {
    type: INBOX_MARK_ALL_READ
  };
};

exports.markAllRead = markAllRead;

var markAllReadPending = function markAllReadPending() {
  return {
    type: INBOX_MARK_ALL_READ_PENDING
  };
};

exports.markAllReadPending = markAllReadPending;

var markAllReadError = function markAllReadError() {
  return {
    type: INBOX_MARK_ALL_READ_ERROR
  };
};

exports.markAllReadError = markAllReadError;

var markAllReadDone = function markAllReadDone(payload) {
  return {
    type: INBOX_MARK_ALL_READ_DONE,
    payload: payload
  };
};

exports.markAllReadDone = markAllReadDone;